document.addEventListener("DOMContentLoaded", () => {
  var videos = document.querySelectorAll(".video_banner_main.video");
  videos?.forEach(function (video) {

     var videoElement = video.querySelector("video");
    if (videoElement) {
     videoElement.play(); 
    }
  
  });   

  // Mobile menu
  var openMenu = document.querySelector(".hamburger_menu_icon");
  var closeMenu = document.querySelector(".menu-drawer_close");
  var menuDrawer = document.querySelector(".menu-drawer");
  var close_outside_menu = document.querySelector(".close_outside_menu");


  openMenu.addEventListener("click", function() {
      menuDrawer.classList.add("menu-right-open");
      close_outside_menu.classList.add("closeOutsideMenu");
  });
  
  closeMenu.addEventListener("click", function() {
      menuDrawer.classList.remove("menu-right-open");
  });

  close_outside_menu.addEventListener("click", function() {
      menuDrawer.classList.remove("menu-right-open");
    close_outside_menu.classList.remove("closeOutsideMenu");
  });



  

  
  
  
});

$(document).ready(function(){
  $('.collection-slider-wrap').slick({
    slidesToShow: 1,
    dots: false,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev slick-arrow custom-prev-arrow"><svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0346 0.936791L0.727365 10.244C0.456825 10.5146 0.456825 10.9532 0.727365 11.2237L10.0346 20.531C10.3051 20.8015 10.7438 20.8015 11.0143 20.531C11.2849 20.2604 11.2849 19.8218 11.0143 19.5513L2.88969 11.4266H22V10.0411H2.88969L11.0143 1.9165C11.2849 1.64596 11.2849 1.20733 11.0143 0.936791C10.7438 0.666252 10.3051 0.666252 10.0346 0.936791Z" fill="white"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow custom-next-arrow"><svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9654 0.936791L21.2726 10.244C21.5432 10.5146 21.5432 10.9532 21.2726 11.2237L11.9654 20.531C11.6949 20.8015 11.2562 20.8015 10.9857 20.531C10.7151 20.2604 10.7151 19.8218 10.9857 19.5513L19.1103 11.4266H0V10.0411H19.1103L10.9857 1.9165C10.7151 1.64596 10.7151 1.20733 10.9857 0.936791C11.2562 0.666252 11.6949 0.666252 11.9654 0.936791Z" fill="white"/></svg></button>'
  });

  $('.featured-cards-slider-wrap').slick({
    dots: true,
    slidesToShow: 2,
    centerMode: true,
    centerPadding: '26.6%',
    prevArrow: '<button type="button" class="slick-prev slick-arrow custom-prev-arrow"><svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0346 0.936791L0.727365 10.244C0.456825 10.5146 0.456825 10.9532 0.727365 11.2237L10.0346 20.531C10.3051 20.8015 10.7438 20.8015 11.0143 20.531C11.2849 20.2604 11.2849 19.8218 11.0143 19.5513L2.88969 11.4266H22V10.0411H2.88969L11.0143 1.9165C11.2849 1.64596 11.2849 1.20733 11.0143 0.936791C10.7438 0.666252 10.3051 0.666252 10.0346 0.936791Z" fill="white"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow custom-next-arrow"><svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9654 0.936791L21.2726 10.244C21.5432 10.5146 21.5432 10.9532 21.2726 11.2237L11.9654 20.531C11.6949 20.8015 11.2562 20.8015 10.9857 20.531C10.7151 20.2604 10.7151 19.8218 10.9857 19.5513L19.1103 11.4266H0V10.0411H19.1103L10.9857 1.9165C10.7151 1.64596 10.7151 1.20733 10.9857 0.936791C11.2562 0.666252 11.6949 0.666252 11.9654 0.936791Z" fill="white"/></svg></button>', 
      responsive: [
        {
          breakpoint: 650, 
          settings: {
            slidesToShow: 1,
            centerPadding: '26.6%'
          }
        }
      ]
  });

   $('.related-products--slider').slick({
    dots: true,
    slidesToShow: 2,
    centerMode: true,
    centerPadding: '26.6%',
    prevArrow: '<button type="button" class="slick-prev slick-arrow custom-prev-arrow"><svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0346 0.936791L0.727365 10.244C0.456825 10.5146 0.456825 10.9532 0.727365 11.2237L10.0346 20.531C10.3051 20.8015 10.7438 20.8015 11.0143 20.531C11.2849 20.2604 11.2849 19.8218 11.0143 19.5513L2.88969 11.4266H22V10.0411H2.88969L11.0143 1.9165C11.2849 1.64596 11.2849 1.20733 11.0143 0.936791C10.7438 0.666252 10.3051 0.666252 10.0346 0.936791Z" fill="white"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow custom-next-arrow"><svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9654 0.936791L21.2726 10.244C21.5432 10.5146 21.5432 10.9532 21.2726 11.2237L11.9654 20.531C11.6949 20.8015 11.2562 20.8015 10.9857 20.531C10.7151 20.2604 10.7151 19.8218 10.9857 19.5513L19.1103 11.4266H0V10.0411H19.1103L10.9857 1.9165C10.7151 1.64596 10.7151 1.20733 10.9857 0.936791C11.2562 0.666252 11.6949 0.666252 11.9654 0.936791Z" fill="white"/></svg></button>', 
      responsive: [
        {
          breakpoint: 650, 
          settings: {
            slidesToShow: 1,
            centerPadding: '26.6%'
          }
        }
      ]
  });

});


document.addEventListener('DOMContentLoaded', () => {
    const navLinks = document.querySelectorAll('.project-submenu .menu-item');
    const navHeight = document.querySelector('.shopify-section-group-header-group.section-header').offsetHeight;
    
      const removeActiveClasses = () => {
          navLinks.forEach(link => link.classList.remove('active'));
      };
      const addActiveClass = (link) => {
          link.classList.add('active');
      };
      navLinks.forEach(link => {
          link.addEventListener('click', (event) => {
              const sectionId = event.target.getAttribute('data-category');
              const section = document.getElementById(sectionId);
              if (section) {
                  window.scrollTo({
                      top: section.offsetTop + navHeight,
                      behavior: 'smooth'
                  });
                  removeActiveClasses();
                  addActiveClass(event.target);
              }
          });
      });
      window.addEventListener('scroll', () => {
          const windscroll = window.scrollY;
          if (windscroll >= 100) {
              const sections = document.querySelectorAll('.category-title');
              sections.forEach((section, i) => {
                  if (section.offsetTop <= windscroll + navHeight) {
                      removeActiveClasses();
                      navLinks[i].classList.add('active');
                  }
              });
          } else {
              removeActiveClasses();
              navLinks[0].classList.add('active');
          }
      });
      window.dispatchEvent(new Event('scroll'));
    
});

